import { useContext } from 'react';
import { useFirestoreGeneralOrderBy } from '../../firebase/useFirestore';
import PublicEventFormContext from '../../StateManagment/PublicEventFormContext';

const SubTargetgroupsEvents = ({ fieldId, targetgroupId, selected = [], onToggle, disabled = false }) => {
  // Op het openbare formulier uit getPublicEventForm; elders (AddEvent) uit
  // Firestore. '' slaat de hook over.
  const publicForm = useContext(PublicEventFormContext);
  const subTargetgroupsRead = useFirestoreGeneralOrderBy(
    'SubTargetgroups',
    'TargetgroupID',
    publicForm ? '' : targetgroupId || "",
    'Position',
    'asc'
  );
  const subTargetgroups = publicForm ? (publicForm.subTargetgroups[targetgroupId] || []) : subTargetgroupsRead;

  const handleChange = (e) => {
    const subId = e.target.value;
    const checked = e.target.checked;
    onToggle(fieldId, targetgroupId, subId, checked);
  };

  return (
    <div id='events-subtargetgroups-container' style={{ marginLeft: 24, opacity: disabled ? 0.5 : 1 }}>
      {subTargetgroups && subTargetgroups.map(sub => (
        <div key={sub.ID} id='add-event-targetgroup-item-container'>
          <input
            type="checkbox"
            value={sub.ID}
            onChange={handleChange}
            checked={selected.includes(sub.ID)}
            disabled={disabled}
          />
          <label>{sub.Title}</label>
        </div>
      ))}
    </div>
  );
};

export default SubTargetgroupsEvents;
